import React from 'react';
import { Sun, Moon } from 'lucide-react';

const ThemeToggle = ({ theme, onToggle }) => {
  return (
    <button
      onClick={onToggle}
      className="theme-toggle-btn"
      title={`Passer en mode ${theme === 'dark' ? 'clair' : 'sombre'}`}
    >
      {theme === 'dark' ? (
        <Sun className="h-6 w-6 theme-icon" />
      ) : (
        <Moon className="h-6 w-6 theme-icon" />
      )}
    </button>
  );
};

export default ThemeToggle;